import { useCallback, useEffect, useMemo, useState } from "react";
import { Container } from "reactstrap";

import ReactTable from "components/ReactTable/ReactTable";
import useFetch from "Hooks/useFetch";
import styles from "Pages/Admin/ClientHealth/ClientHealth.module.css";
import DefaultColumnFilter from "components/ReactTable/Components/DefaultColumnFilter/DefaultColumnFilter";
import usePageTitle from "Hooks/usePageTitle";

export default function CompanyMethods() {
    const [methods, setMethods] = useState<ICompanyMethod[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    usePageTitle("Methods Used");
    const { get } = useFetch();

    const getMethods = useCallback(
        async (ignore: boolean) => {
            if (ignore) return;

            setIsLoading(true);

            const response = await get(`/api/admin/company_methods`);

            if (response.ok && !ignore) {
                const data = await response.json();
                console.log(data);
                setMethods(data);
            }
            setIsLoading(false);
        },
        [get]
    );

    useEffect(() => {
        let ignore = false;

        getMethods(ignore);

        return () => {
            ignore = true;
        };
    }, [getMethods]);

    const columns = useMemo(() => {
        const cellContent = (value: string) => {
            return <span style={{ color: "red" }}>{value}</span>;
        };

        return [
            {
                Header: "Company",
                accessor: "company",
                // Not using default filter, so as to allow for auto focusing this input
                Filter: ({ column }: any) => {
                    return <DefaultColumnFilter column={column} autoFocus />;
                },
            },
            {
                Header: "Provider",
                accessor: "provider_name",
            },
            {
                Header: "Systems",
                accessor: "systems",
            },
            {
                Header: "Integration Method",
                accessor: "process",
            },
            {
                Header: "Integration Name",
                accessor: "name",
            },
            {
                Header: "Exists",
                accessor: "method_exists",
                width: 50,
                disableFilters: true,
            },
            {
                Header: "Direction",
                accessor: "direction",
            },
            {
                Header: "Details",
                accessor: "details",
                Cell: ({ value }: { value: string }) => cellContent(value),
            },
        ];
    }, []);

    const tableProps = {
        columns,
        data: methods,
        showPagination: true,
        showContextMenu: true,
        isLoading,
    };

    return (
        <Container fluid>
            <div className={styles.headerAndButtonsBox}>
                <h1>Methods Used By Companies</h1>
            </div>

            <ReactTable {...tableProps} />
        </Container>
    );
}
